






import { Vue, Component, Prop } from 'vue-property-decorator';
import faker from 'faker';

@Component({})
export default class AddProperty extends Vue {
  @Prop({ type: String, required: true }) readonly type!: string;
  isVisible = false;

  get typeDisplayName (): string {
    return this.type.toLowerCase().charAt(0).toUpperCase() + this.type.toLowerCase().slice(1);
  }

  addProperty () {
    this.$emit('addProperty', this.type, faker.commerce.product().toLowerCase());
  };

  setFocus () {
    (this.$refs.newPropField as HTMLElement).focus();
  };
};
